import { getTestId } from '@airtel/air-design-system';
var data = [{
  prefix: {
    text: '1.',
    type: 'body-para-sm',
    prefixAlign: 'left'
  },
  content: [{
    text: 'The launch date for the new MNP process is 16-Dec-2019.',
    type: 'body-para-sm'
  }, {
    text: 'The launch date for the new MNP process is 16-Dec-2019.',
    type: 'body-para-sm'
  }, {
    text: 'njbefc',
    type: 'body-para-sm'
  }]
}, {
  prefix: {
    text: '2.',
    type: 'body-para-sm',
    prefixAlign: 'left'
  },
  content: [{
    text: 'The launch date for the new MNP process is 16-Dec-2019.',
    type: 'body-para-sm'
  }, {
    text: 'The launch date for the new MNP process is 16-Dec-2019',
    type: 'body-para-sm'
  }, {
    text: 'view more',
    type: 'body-para-sm'
  }]
}];
export var defaultProps = Object.assign({
  dataArray: data,
  typographyStyle: {}
}, getTestId('ListWidgetContainer'));